export const raceLevelMap = {
  INTERNATIONAL: 'MS/ME',
  NATIONAL:      'MČR/NŽ',
  // REGIONAL:      '',
  // DISTRICT:      '',
  // TRAINING:      '',
  // OTHER:         '',
}

export const eventTypeMap = {
  repre: 'REPRE',
  scm:   'SCM',
  association: 'AROB',
};

const eventTypes = new Set(Object.keys(eventTypeMap));


/**
 * Pokud je event.event_type jedním z eventTypeMap, vrátí jeho prefix,
 * jinak hledá v races prefix podle raceLevelMap.
 */
export function levelPrefix({ event_type, races }) {
  if (eventTypes.has(event_type)) {
    return `(${eventTypeMap[event_type]})\u00A0`;
  }
  for (const lvl of Object.keys(raceLevelMap)) {
    if (races.some(r => r.race_level === lvl)) {
      return `(${raceLevelMap[lvl]})\u00A0`;
    }
  }
  return '';
}